export default class Item {
    public key: any;
    public title: string;

    constructor(value: any, label: string) {
        this.key = value;
        this.title = label;
    }

    public static fromValue(items: Item[], value: number): Item {
        let res: Item = new Item(0, 'Sélectionner');
        items.forEach(i => {
            if (i.key == value) {
                res = i;
            }
        });
        return res;
    }
}